import { useUserStore } from '@/store/userStore';

/**
 * Single source of truth for "does this user have an active Priestess sub?"
 *
 * Mirrors the backend `app/services/subscription.is_priestess` check so
 * that paywall UI matches what the API will accept.
 */
export function useSubscription() {
  const user = useUserStore((s) => s.user);

  const isPriestess = (() => {
    if (!user) return false;
    if (user.subscription_tier !== 'priestess') return false;
    if (!user.subscription_expires_at) return false;
    try {
      return new Date(user.subscription_expires_at).getTime() > Date.now();
    } catch {
      return false;
    }
  })();

  return { isPriestess };
}
